import { UrlConstants } from "../url.constants";
export class ApiProxyConstants {
    static URL = `${UrlConstants.API_V2}Proxy`;
    static URL_POST = `${UrlConstants.API_V2}Proxy/ProxyPost`;
    static URL_LAYER_TOKEN = `${UrlConstants.API_V2}Proxy/GetLayerToken`;
    static FUNCTION_CHECK_SECURE_URL = `${UrlConstants.API_V2}CheckSecureURL`;
    static QUERY_PREFIX = `?`;
    static PARAMETER_PREFIX = `&`;
}
